<template lang="html">


  <section class="post-xl flex justify-start">
    <span class="background" :style="`background: url(${server+data.img.enlace}) center/cover no-repeat`"></span>
    <router-link class="link-dest" :to="$t('enlaces.blog_noticia')+'/'+slug"></router-link>
    <div class="col-50 waypoints flex" data="fadeInLeft">
      <div class="container-text flex column justify-center">
        <span class="date">{{data.fecha | dateToHuman}}</span>
        <h3 v-html="data.titulo"></h3>
        <p v-html="data.entradilla"></p>
        <ul class="flex row likes-xl">
          <li><i class="fa fa-eye" aria-hidden="true"></i><span>{{data.hints}}</span></li>
          <li><i class="fa fa-comment-o" aria-hidden="true"></i><span>{{data.comentarios}}</span></li>
          <like :likes="data.likes" :slug="data.slugs[lang]"></like>
        </ul>
        <div class="flex row-reserve justify-between">
          <div class="tag" :to="$t('enlaces.blog_noticia')+'/'+data.categoria.slug">{{data.categoria.nombre}}</div>
          <div class="mas-dark"></div>
        </div>

      </div>
    </div>
  </section>

</template>

<script lang="js">

  import {mapGetters} from 'vuex';


  import like from '@/components/parts/like'

  export default  {
    name: 'destacado-blog-el',
    props: ['data'],
    mounted() {

    },
    data() {
      return {

      }
    },
    components: {
      like
    },
    computed: {
     ...mapGetters({
      lang: 'getLanguage',
      server : 'getServer'
    }),
    slug: function () {
      return this.data.slugs[this.lang] ? this.data.slugs[this.lang] : this.data.slugs["en"];
    }
   },
   filters : {
        dateToHuman: function (value) { 
          let date = new Date(value);
          let dateString = `${date.getDate()}-${date.getMonth()+1}-${date.getFullYear()}`;
          return dateString;
        }
      }
    }
  </script>

  <style scoped>
  
  .post-xl{
    justify-content: flex-start;
    -webkit-justify-content: flex-start;
  }

  .background{
    width: 50%;
    height: 100%;
    position: absolute;
    right: 0;
    top: 0;
    display: inline-block;
  }

  .post-xl > div{
    justify-content: flex-end;
    -webkit-justify-content: flex-end;
  }
  .post-xl:nth-child(2n - 1) > div{
   justify-content: flex-start;
   -webkit-justify-content: flex-start; 
 }

 .post-xl:nth-child(2n - 1){
  justify-content: flex-end;
  -webkit-justify-content: flex-end;
}
.post-xl:nth-child(2n - 1) .background{
  left: 0;
  right: auto;
}

@media screen and (max-width: 768px){
  .post-xl{
    -webkit-flex-direction: column;
    -moz-flex-direction: column;
    -ms-flex-direction: column;
    -o-flex-direction: column;
    flex-direction: column;
  }

  .background{
    position: relative;
    left: auto;
    top: auto;
    width: 100%;
    height: 45vw;
  }

  .post-xl .col-50{
    position: relative;
    width: 100%;
    padding: 20px;
    justify-content: center;
  }

  .post-xl .container-text{
    padding: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/parts/destacado-blog-el.vue